import React, { useState } from "react";
import Pages from "components/common/Pages";
import uuidv4 from "uuid/v4";
import { track } from "utils/analytics";
import get from "lodash/get";

const formattedDate = () => {
  const d = new Date(Date.now());
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
};

const AreYouSure = ({
  next,
  processPayment,
  user,
  defaultPaymentMethod,
  completeUpdate,
  autopayType,
  close
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const handleClick = async () => {
    setLoading(true);
    processPayment({
      variables: {
        userId: user.email,
        payment_method: defaultPaymentMethod || user.payment_methods[0].id,
        amount: parseFloat(user.credit.credit_used.toFixed(2)),
        idempotencyKey: uuidv4()
      },
      onCompleted: data => {}
    })
      .then(async res => {
        if (
          get(res, "data.processPayment.status") &&
          // eslint-disable-next-line
          res.data.processPayment.status.toLowerCase() == "error"
        ) {
          throw new Error("Error processing your payment");
        }
        console.log("COMPLETED");
        track("DASHBOARD_PAYMENT_SUCCESS");
        await completeUpdate();
        next();
        return { status: "OK" };
      })
      .catch(e => {
        console.log(e.message);
        setError("Payment Failed");
        track("DASHBOARD_PAYMENT_FAILURE", {
          message: e
        });
        throw new Error({ status: "ERROR", message: e.message });
        // return { status: "EROR", message: e.message };
      });
  };

  // eslint-disable-next-line
  const paymentMethod = defaultPaymentMethod
    ? user.payment_methods.find(method => method.id === defaultPaymentMethod)
    : user.payment_methods[0];

  const amount = user.credit.credit_used.toFixed(2);

  console.log("paymentMethod", paymentMethod);

  return (
    <>
      <div className="text-center font-bold text-xl mb-4">
        Please make a payment
      </div>
      <p className="text-center">
        {`Before switching to ${
          autopayType === "biweekly" ? "bi-weekly" : autopayType
        } autopay, you must first pay off your current balance.`}
      </p>

      <div className="flex mt-3 mb-3 justify-center">
        <p className="font-semibold mr-1">Amount Due: </p>
        <p>{`$${amount}`}</p>
      </div>
      <p className="text-center">
        {`This payment will be processed using account: **${paymentMethod.account_number_last_four}`}
      </p>
      <div className="flex mt-8 items-center flex-col">
        <div>
          <button
            type="button"
            className="btn btn-green px-10"
            onClick={handleClick}
            disabled={loading}
          >
            Submit Payment
          </button>
        </div>
        <p
          className="text-xs text-gray-600 text-justify pt-4"
          style={{ maxWidth: "300px" }}
        >
          {`By clicking “Submit Payment” you are authorizing us to initiate a debit on
          your behalf, from your ${paymentMethod.institution} Account (...${
            paymentMethod.account_number_last_four
          }) for ${amount} on
          ${formattedDate()}. You agree that you will not dispute this transaction, so
          long as the transaction corresponds to the terms of this
          authorization. Please click below if you'd like to cancel.`}
        </p>
        {error && <p>{error}</p>}
        <p className="mt-2 underline cursor-pointer" onClick={close}>
          No thanks
        </p>
      </div>
    </>
  );
};

const PaymentSuccess = ({ close, autopayType }) => (
  <div>
    <p className="text-center font-bold text-xl mb-4 text-primary">
      Payment Success
    </p>
    <p className="px-8">
      {`Your payment was successful! You have now been switched to ${autopayType} autopay.`}
    </p>
    <div className="flex mt-6 justify-center">
      <button type="button" className="btn px-10" onClick={close}>
        Close
      </button>
    </div>
  </div>
);

const SettingsPaymentModal = ({
  closeModal,
  processPayment,
  user,
  defaultPaymentMethod,
  autopayType,
  completeUpdate
}) => (
  <div style={{ backgroundColor: "#FAFAFA" }} className="py-8 px-12">
    <Pages>
      <AreYouSure
        close={closeModal}
        processPayment={processPayment}
        defaultPaymentMethod={defaultPaymentMethod}
        user={user}
        completeUpdate={completeUpdate}
        autopayType={autopayType}
      />
      <PaymentSuccess close={closeModal} autopayType={autopayType} />
    </Pages>
  </div>
);

export default SettingsPaymentModal;
